import { Suspense } from "react";
import { useSuspenseQuery } from "@tanstack/react-query";
import { crawlerLinksQueryOptions } from "@/components/CrawlerLinksStrip";
import type { CrawlerLink } from "@/lib/crawler-links.functions";

/**
 * Admin-controlled link block rendered INSIDE the site-wide footer
 * directory nav — same DOM zone (`footer > nav.border-b`) where Googlebot
 * historically discovered /city/india/* URLs on /pakistan and /india.
 *
 * Renders as raw HTML `<a>` anchors (no JS gating) so crawlers pick them up
 * on the very next fetch. Managed via /admin-portal → Crawler Links → Footer.
 */
export function FooterCrawlerLinks() {
  return (
    <Suspense fallback={null}>
      <Inner />
    </Suspense>
  );
}

function Inner() {
  const { data } = useSuspenseQuery(crawlerLinksQueryOptions("footer"));
  if (!data || data.length === 0) return null;
  return (
    <div
      className="mx-auto max-w-6xl px-4 pb-6 -mt-2 text-xs"
      data-crawler-strip="footer"
    >
      <div className="font-bold text-foreground mb-2">Editor&apos;s picks</div>
      <ul className="flex flex-wrap gap-x-4 gap-y-1.5 text-muted-foreground">
        {data.map((row: CrawlerLink) => (
          <li key={row.id}>
            <a href={row.url} className="hover:text-gold">
              {row.label}
            </a>
          </li>
        ))}
      </ul>
    </div>
  );
}